import styled from "styled-components";

export const HorizontalRule = styled.hr`
    width: 80%;
    height: 0;
    border: 0;
    border-bottom: thin solid rgba(0,0,0,0.2);
    margin: 1rem auto;
`;